module.exports = __webpack_public_path__ + "img/courseiter.255bf7c3.svg";